var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "26.049",
        height: "31.05",
        viewBox: "540.976 293.975 26.049 31.05",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M555.042 300.744h8.683l1.086 1.129v4.58h1.128l1.086 1.129v2.188l-1.086 1.129h-1.128v6.77l-1.086 1.128h-6.773l-5.426 6.228-1.867-.813v-5.415h-5.427l-1.086-1.445V310.9h-1.085l-1.085-1.129v-2.188l1.085-1.129h1.085v-4.896l1.15-.813h8.684v-2.572a2.268 2.268 0 0 1-1.15-1.94c0-1.247.971-2.257 2.17-2.257 1.2 0 2.171 1.01 2.171 2.256a2.267 2.267 0 0 1-1.129 1.873v2.64Zm7.641 9.026V303h-17.366v13.224l5.427.316h1.085v4.942l3.908-4.603.76-.339h6.186v-6.77Zm-4.602 1.151a5.82 5.82 0 0 1-2.974 1.67v-.022c-1.909.38-3.875-.246-5.253-1.67l-1.52 1.602a7.844 7.844 0 0 0 2.584 1.783 7.9 7.9 0 0 0 3.082.654c2.099-.013 4.11-.88 5.6-2.415l-1.519-1.602Zm-7.359-4.535h-2.17v2.256h2.17v-2.256Zm6.513 0h2.17v2.256h-2.17v-2.256Z",
          "data-name": "supsis-chatbot-svg",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }